import lottie from 'lottie-web';
import { useEffect, useRef, useState } from 'react';
import './ResellerTableInitial.scss';
import { MIS_RESELLER_REPORT } from '../../../Constants/strings';

const ResellerTableInitial = () => {
  const [animationData, setAnimationData] = useState(null);
  const animationContainer = useRef(null);

  useEffect(() => {
    import('../../../Assets/images/json/dar_reseller_report_load.json').then(
      ({ default: defAnimationData }) => {
        setAnimationData(defAnimationData);
      },
    );
  }, []);

  useEffect(() => {
    if (animationData) {
      lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      });
    }
  }, [animationData]);
  return (
    <div className="reseller-report-initial-loader-outer-layer">
      <div ref={animationContainer} className="reseller-table-initial-loader">
        {MIS_RESELLER_REPORT.LOADER_TEXT}
      </div>
    </div>
  );
};

export default ResellerTableInitial;
